export function parseScheduleMessageMeta(message) {
  if (!message?.dataJson) return null;
  const raw = message.dataJson;
  try {
    const parsed = typeof raw === "object" ? raw : JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function isScheduledPendingMessage(message) {
  const meta = parseScheduleMessageMeta(message);
  return meta?.scheduled === true;
}

export function isTemplateMessage(message) {
  const meta = parseScheduleMessageMeta(message);
  return (
    message?.mediaType === "template" ||
    meta?.isTemplate === true ||
    Boolean(meta?.templateId)
  );
}

export function getMessageDisplayTimestamp(message) {
  const meta = parseScheduleMessageMeta(message);
  if (meta?.scheduled && meta?.sendAt) {
    return meta.sendAt;
  }
  return message?.createdAt ?? null;
}

export function formatScheduleTooltip(meta) {
  if (!meta?.sendAt) return "Mensaje programado";
  try {
    const date = new Date(meta.sendAt);
    if (Number.isNaN(date.getTime())) return "Mensaje programado";
    return `Programado para ${date.toLocaleString(undefined, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  } catch {
    return "Mensaje programado";
  }
}
